module.exports = require('./helpers/bundle-url').getBundleURL('eO6Hv') + "logo-dark.a922e36b.svg";